module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "list-style": "none"
    },
    attrs: {
      "id": _vm.bindId
    }
  }, [_c('div', {
    staticClass: "dropdown-toggle unselectable notification-bell ",
    attrs: {
      "href": "javascript:;",
      "role": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: " fa fa-bell-o animated",
    class: {
      'swing': _vm.active
    },
    on: {
      "mouseover": function($event) {
        _vm.active = true
      },
      "mouseleave": function($event) {
        _vm.active = false
      }
    }
  }), (_vm.unreadNotificationsComp.length > 0) ? _c('label', {
    staticClass: "badge badge-error"
  }, [_vm._v(_vm._s(_vm.unreadNotificationsComp.length))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right scrollable-menu"
  }, [_vm._l((_vm.notificationsComp), function(notification, index) {
    return _c('li', {
      key: notification.UserNotificatoionId
    }, [_c('div', {
      staticClass: "custom-class",
      class: {
        read: notification.IsRead
      }
    }, [_c('h5', [_c('button', {
      staticClass: "close",
      staticStyle: {
        "font-size": "xx-large"
      },
      attrs: {
        "type": "button",
        "data-dismiss": "alert",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.deleteNotification(notification)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "3px"
      }
    }, [_c('img', {
      staticClass: "img img-circle",
      staticStyle: {
        "width": "auto",
        "height": "30px"
      },
      attrs: {
        "src": notification.ProfilePic,
        "crossOrigin": "Anonymous"
      }
    })]), _vm._v(" "), _c('strong', {
      staticClass: "bold-text"
    }, [_vm._v(_vm._s(notification.SenderName))]), _vm._v("   Booking :"), _c('strong', [_vm._v(" " + _vm._s(notification.BookingNumber) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "h5",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "5px",
        "margin-left": "5px"
      }
    }, [_vm._v("\n          " + _vm._s(notification.Title) + " "), _c('small', {
      staticClass: "pull-right text-muted"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-time text-muted"
    }), _vm._v(" " + _vm._s(_vm.sentDate(notification.SentDate)))])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-block",
      on: {
        "click": function($event) {
          _vm.viewNotification(notification)
        }
      }
    }, [_vm._v("Visit Booking Page")]), _vm._v(" "), (index != (_vm.notificationsComp.length - 1)) ? _c('hr', {
      staticStyle: {
        "margin-bottom": "0px"
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.notificationsComp.length == 0) ? _c('li', [_vm._m(0)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-class"
  }, [_c('h5', {
    staticClass: "text-muted text-center"
  }, [_c('strong', [_vm._v(" Dupaws notifications")])]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("You dont have any notifications yet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3059a716!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/Notifications.vue
// module id = 622
// module chunks = 2